<template>
	<div id="app">
    <div id="layimSmall" class="layim-small" @click="openLayim()">
			<i class="layim-new" id="LAY_layimMsg"></i>
      <em class="iconfont icon-closecircled" id="layimSmallDisConnect"></em>
      <div class="spinner" id="layimSmallConnecting">
  <div class="rect1"></div>
  <div class="rect2"></div>
  <div class="rect3"></div>
</div>
			<span class="iconfont icon-liaotian"></span>
		</div>
		<!--<transition  name="slide-fade">-->
		<!--<keep-alive include="">-->
		<router-view></router-view>
		<!--</keep-alive>-->
		<!--</transition>-->
		<!--<router-view></router-view>-->
		
	</div>
</template>

<script>
import { Indicator } from "mint-ui";
import storeState from "@/store";
let beforeUrl=''
export default {
  name: "app",
  mounted() {
  this.$router.beforeEach((to, from, next) => {
				beforeUrl = from.path;
				next();
			})
    if (store.get("user") && store.get("user").user_id&&beforeUrl.indexOf('login')<0) {
      layuiOpen();
    }
    if (window.plus) {
      plusReady();
    } else {
      document.addEventListener("plusready", plusReady, false);
    }

    function plusReady() {
      plus.navigator.closeSplashscreen();
    }
    this.$router.beforeEach((to, from, next) => {
      // 记录上一个页面的scroll位置
      if (from.name) {
        let contentElem = document.querySelector(".mint-loadmore");
        let scrollTop = contentElem ? contentElem.scrollTop : "0";
        storeState.commit({
          type: "setState",
          attr: "scrollPos",
          value: scrollTop
        });
      }
      next();
    });
    this.touchMove();
  },
  methods: {
    openLayim: function() {
      $(".layui-m-layermain").fadeIn("fast");
      if($('#layimSmallDisConnect').css('display')=='block'){
reconnectInit();
      }
    },
    touchMove: function() {
      var cont = $("#layimSmall");
      var contW = $("#layimSmall").width();
      var contH = $("#layimSmall").height();
      var startX, startY, sX, sY, moveX, moveY, leftX, rightX, topY, bottomY;
      var winW = $(window).width();
      var winH = $(window).height();
      var body = $("body");

      cont.on({
        //绑定事件
        touchstart: function(e) {
          startX = e.originalEvent.targetTouches[0].pageX; //获取点击点的X坐标
          startY = e.originalEvent.targetTouches[0].pageY; //获取点击点的Y坐标
          //console.log("startX="+startX+"************startY="+startY);
          sX = $(this).offset().left; //相对于当前窗口X轴的偏移量
          sY = $(this).offset().top; //相对于当前窗口Y轴的偏移量
          //console.log("sX="+sX+"***************sY="+sY);
          leftX = startX - sX; //鼠标所能移动的最左端是当前鼠标距div左边距的位置
          rightX = winW - contW + leftX; //鼠标所能移动的最右端是当前窗口距离减去鼠标距div最右端位置
          topY = startY - sY; //鼠标所能移动最上端是当前鼠标距div上边距的位置
          bottomY = winH - contH + topY; //鼠标所能移动最下端是当前窗口距离减去鼠标距div最下端位置
        },
        touchmove: function(e) {
          e.preventDefault();
          moveX = e.originalEvent.targetTouches[0].pageX; //移动过程中X轴的坐标
          moveY = e.originalEvent.targetTouches[0].pageY; //移动过程中Y轴的坐标
          //console.log("moveX="+moveX+"************moveY="+moveY);
          if (moveX < leftX) {
            moveX = leftX;
          }
          if (moveX > rightX) {
            moveX = rightX;
          }
          if (moveY < topY) {
            moveY = topY;
          }
          if (moveY > bottomY) {
            moveY = bottomY;
          }
          $(this).css({
            left: moveX + sX - startX,
            top: moveY + sY - startY
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
#app {
  background-color: #EDF2FA;
  margin: 0 auto;
  height: 100%;
  max-width: 750px;
  position: relative;
  font-size: 0.3rem;
  overflow: hidden;
  .layim-small {
    position: absolute;
    top: 9.3rem;
    width: 1rem;
    height: 1rem;
    background: rgba(0, 122, 255, 0.62);
    border-radius: 50%;
    text-align: center;
    right: 0.2rem;
    z-index: 222;
    display: none; /* 白底风格：隐藏浮动 layim 入口 */
    span {
      line-height: 1rem;
      color: black;
      font-size: 0.6rem;
    }
  }
  .icon-closecircled{
    position: absolute;
    right: 0;
    display: none;
    color: #C23531;
  }
  .spinner {
    display: none;
  height: 0.3rem;
  right: 0;
  text-align: center;
  font-size: 0.2rem;
  position: absolute;
}
 
.spinner > div {
  background-color: #218df9;
  height: 100%;
  width: 0.06rem;
  display: inline-block;
   
  -webkit-animation: stretchdelay 1.2s infinite ease-in-out;
  animation: stretchdelay 1.2s infinite ease-in-out;
}
.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}
 
.spinner .rect3 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}
 
@-webkit-keyframes stretchdelay {
  0%, 40%, 100% { -webkit-transform: scaleY(0.4) } 
  20% { -webkit-transform: scaleY(1.0) }
}
 
@keyframes stretchdelay {
  0%, 40%, 100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }  20% {
    transform: scaleY(1.0);
    -webkit-transform: scaleY(1.0);
  }
}
}
</style>


// WEBPACK FOOTER //
// src/App.vue